import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { SearchPagination, SearchResults } from '@uncinc/react-searchkit';

import { SearchAllProjectsHit } from '../types';
import Hit from './Hit';

import './style.scss';

const SearchAllProjectsResults: React.FC = () => {
  const { t } = useTranslation();

  const classNames = c('SearchAllProjects__Results');

  return (
    <div className={classNames}>
      <SearchResults renderItem={(hit: SearchAllProjectsHit) => <Hit hit={hit} />} />

      <div className="mt-4">
        <SearchPagination
          previousLabel={t('buttons.previous')}
          nextLabel={t('buttons.next')}
        />
      </div>
    </div>
  );
};

export default SearchAllProjectsResults;
